function trimTrailingSlash(value: string): string {
  return value.replace(/\/$/, "");
}

/**
 * Resolve the app base path at runtime for both custom domains and project Pages.
 */
export function resolveAppBasePath(): string {
  const base = import.meta.env.BASE_URL;
  if (base !== "./") {
    return trimTrailingSlash(base);
  }

  if (window.location.hostname.endsWith(".github.io")) {
    const parts = window.location.pathname.split("/").filter(Boolean);
    if (parts.length > 0) return `/${parts[0]}`;
  }

  return "";
}

export function buildAppUrl(pathname: string): string {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${window.location.origin}${resolveAppBasePath()}${normalizedPath}`;
}
